import { useState, useCallback } from "react";
import { getUserByMobile } from "../services/myUserService";

/**
 * useUserNameFetch Hook
 * Fetches user name based on mobile number input
 * Memoized for optimal performance
 * 
 * @returns {Object} User name state and handlers
 */
export const useUserNameFetch = () => {
  const [userName, setUserName] = useState("");
  const [nameCheck, setNameCheck] = useState("");
  const [isDisabled, setIsDisabled] = useState(false);

  // Memoized fetch handler
  const fetchUserName = useCallback(async (mobileNumber) => {
    if (mobileNumber?.length === 10) {
      const response = await getUserByMobile(mobileNumber);
      const fetchedName = response?.data?.[0]?.name;
      
      setNameCheck(fetchedName);
      
      if (fetchedName === "Unknown") {
        setUserName("");
        setIsDisabled(false);
      } else {
        setUserName(fetchedName);
        setIsDisabled(true);
      }
    } else {
      setUserName("");
      setIsDisabled(false);
    }
  }, []);

  const resetUserName = useCallback(() => {
    setUserName("");
    setNameCheck("");
    setIsDisabled(false);
  }, []);

  return {
    userName,
    setUserName,
    nameCheck,
    isDisabled,
    fetchUserName,
    resetUserName,
  };
};
